import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const useVaultMeta = () => {
  const [m, setM] = useState({ settings: null, locations: [], people: [] });
  useEffect(() => {
    Promise.all([api.get("/vault/settings"), api.get("/vault/locations"), api.get("/users/assignable?team=1").catch(() => ({ data: [] }))])
      .then(([s, l, p]) => setM({ settings: s.data, locations: l.data, people: p.data })).catch(() => {});
  }, []);
  return m;
};

export const fmtDT = (v) => (v ? new Date(v).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtD = (v) => (v ? new Date(`${v.slice(0, 10)}T00:00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const localDT = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 16); };
export const today = () => localDT().slice(0, 10);

export const StatusPill = ({ f, testid }) => {
  const [cls, label] = f.overdue ? ["bg-rose-50 text-rose-700 border-rose-200", `Overdue ${f.days_overdue}d`]
    : f.status === "issued" ? ["bg-amber-50 text-amber-800 border-amber-200", "Issued out"] : ["bg-emerald-50 text-emerald-800 border-emerald-200", "In storage"];
  return <span data-testid={testid} className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-sm border ${cls}`}>{label}</span>;
};

export const F = ({ label, children, className = "" }) => (
  <div className={className}><Label className="text-xs uppercase tracking-wider text-slate-500">{label}</Label><div className="mt-1">{children}</div></div>
);

export const Pick = ({ value, onChange, options, placeholder, testid, allLabel }) => (
  <Select value={value || (allLabel ? "all" : undefined)} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
    <SelectTrigger data-testid={testid} className="bg-white"><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {allLabel && <SelectItem value="all">{allLabel}</SelectItem>}
      {options.map((o) => <SelectItem key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</SelectItem>)}
    </SelectContent>
  </Select>
);


export const LOC_BLANK = { premises: "", room: "", storage_unit: "", shelf: "", section: "", remarks: "", is_active: true };
export const LOC_FIELDS = [["premises", "Premises", "e.g. Head office, Andheri"], ["room", "Room", "e.g. Records room"], ["storage_unit", "Storage unit / rack / cabinet", "e.g. Cabinet C2"],
  ["shelf", "Shelf", "e.g. 3"], ["section", "Section", "e.g. B"], ["remarks", "Remarks", ""]];
